<template>
  <div>
    <news-letter-form @submit="updatePost"
                      :data="currentNewsLetter"
                      :loading="loading">
    </news-letter-form>
  </div>
</template>
<script>
  import NewsLetterForm from './NewsLetterForm'
  import NewsLetterService from 'src/services/NewsLetterService'

  export default {
    name: 'news-letter-edit',
    components: {
      NewsLetterForm
    },
    data () {
      return {
        loading: false
      }
    },
    computed: {
      currentNewsLetter () {
        return this.$store.state.newsletter.currentNewsLetter
      }
    },
    methods: {
      async updatePost (post) {
        try {
          this.loading = true
          await NewsLetterService.update(post.id, post)
          this.$router.push('/content/newsletter')
        } catch (e) {
          console.warn(e)
        }
        this.loading = false
      }
    }
  }
</script>
<style>
</style>
